import type { Onboarding, OnboardingInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapOnboardingToOnboardingInput = (onboarding: Onboarding): OnboardingInput => ({
  toPartyId: onboarding.to.id,
  shareSeries: mapShareSeriesToShareSeriesInput(onboarding.shareSeries),
  paid: onboarding.paid,
});
